/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck
import { getConfig } from "@/config/appConfig";
import axios from "axios";

export interface Error {
  status: number;
  message: string;
}

function getHeaders() {
  return {
    "Content-Type": "application/json",
    "Ocp-Apim-Subscription-Key": getConfig().VITE_APP_API_KEY,
  };
}

const getBaseURL = () => {
  return getConfig().VITE_APP_API_BASE_URL;
};

// withCredentials sends/receives HttpOnly auth cookies automatically.
// Token refresh is handled transparently by the server-side
// TokenAutoRefreshMiddleware — clients never need to refresh manually.
const api = axios.create({
  baseURL: getBaseURL(),
  headers: getHeaders(),
  withCredentials: true,
});

api.interceptors.response.use(
  (response) => response,
  async (err) => {
    const customError: Error = {
      status: err.response?.status,
      statusText: err.response?.statusText,
      message: err.response?.data,
    };

    if (err.response?.status === 401) {
      // Hard 401 — server could not authenticate even after auto-refresh.
      // Tear down the local session and send the user to the login page.
      import("../utils/sessionCleanup").then(({ clearUserSession }) =>
        clearUserSession(),
      );
    }

    return Promise.reject(customError);
  },
);

// Legacy stubs kept so callers that have not yet been migrated don't crash.
// They are no-ops: tokens now live exclusively in HttpOnly cookies.
export const getLoginRes = (): null => null;

export const setLoginRes = (_data: unknown): void => undefined;

export default api;
